import { AUTHORIZATION_HEADER } from '../../../../../../../src/authorization';
import { send } from '../../../../../../../src/network';
import { type CustomerProductRating } from '../../../../../../../src/types/CustomerProductRating';

export type Params = {
  id: number;
};

export async function getApiV2CustomersSelfProductRatingsId(params: Params) {
  return await send<CustomerProductRating>({
    path: `/api/v2/customers/self/product_ratings/${params.id}/`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
